import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button
} from '@mui/material';

import {
    HomeWork,
    PeopleAlt,
    Wifi,
    Weekend,
    EmojiEvents,
    CheckCircle,
    MeetingRoom,
    WorkOutline,
    LaptopChromebook,
    PersonSearch,
    BeachAccess,
    Bolt,
    Group,
    Star
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: 3 }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.2rem' }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    導入
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.2rem' }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('property-features')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    社会人向け物件の特徴
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.2rem' }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('roommate-selection')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    仕事リズムに合う相手選び
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.2rem' }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('telework-environment')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    テレワーク環境のポイント
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.2rem' }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('switching-work-private')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    仕事とプライベートの切り替え術
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.2rem' }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('success-case')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    社会人ルームシェアの成功事例
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入 */}
            <Box id="introduction" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    社会人ルームシェアの新常識：仕事も暮らしももっと快適に
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    「仕事もプライベートも充実させたい」――そんな社会人の願いを叶える住まいの選択肢として、ルームシェアが近年注目を集めています。ひとり暮らしよりもコストパフォーマンスが高く、交流や刺激も得られる一方、社会人ならではの課題もあります。本記事では、<b>社会人に最適なルームシェアの選び方と、仕事と両立する快適な住環境づくり</b>について、最新トレンドと実践ノウハウを交えてご紹介します。
                </Typography>
                <Box sx={{ my: 3 }}>
                    <img
                        src="/images/blog/roommates-working-living_shakaijin-no-tame-no-roomshare-erabi.jpg"
                        alt="明るい共有リビングで複数人の社会人が各自のノートパソコンで仕事や会話を楽しみながら過ごしている様子。ナチュラルな木目の家具と観葉植物が調和し、現代的で落ち着いた雰囲気を演出している。"
                        style={{ width: '100%', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
                    />
                </Box>
            </Box>

            {/* 社会人向けルームシェア探しのポイント */}
            <Box id="property-features" sx={{ mb: 5 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <HomeWork sx={{ mr: 1, verticalAlign: 'bottom', color: 'primary.main' }} />
                    社会人向け物件のポイント
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    社会人向けルームシェア探しには、仕事の効率や生活の質を高める工夫が必要です。以下は、選ぶ際に注目したい主なポイントです。
                </Typography>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={6}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                            <List>
                                <ListItem>
                                    <ListItemIcon>
                                        <Wifi color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={<Typography fontWeight="bold">高速インターネット完備</Typography>}
                                        secondary="テレワークやオンライン会議も快適"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <MeetingRoom color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={<Typography fontWeight="bold">個室＋共用スペース</Typography>}
                                        secondary="オン/オフの切り替え、集中とリラックスの両立"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <LaptopChromebook color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={<Typography fontWeight="bold">ワークスペース設置</Typography>}
                                        secondary="デスクやモニターなど備品も充実"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
                            <List>
                                <ListItem>
                                    <ListItemIcon>
                                        <BeachAccess color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={<Typography fontWeight="bold">好立地・アクセス良好</Typography>}
                                        secondary="駅近やバス停も近く、通勤も便利"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <Weekend color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={<Typography fontWeight="bold">充実した共用設備</Typography>}
                                        secondary="キッチン、ランドリー、ラウンジなど"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <Bolt color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={<Typography fontWeight="bold">防音/セキュリティ対策</Typography>}
                                        secondary="仕事の集中も安心の環境"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                    </Grid>
                </Grid>
                <Typography variant="body2" color="text.secondary">
                    物件選びは「自分のワークスタイル」と「生活リズム」に合うかどうかが最大のポイント。見学時はネット速度や設備の実用性も必ずチェックしましょう。
                </Typography>
                <Box sx={{ my: 3 }}>
                    <img
                        src="/images/blog/working-space-share_shakaijin-no-tame-no-roomshare-erabi.jpg"
                        alt="シェアハウスの共用ワークスペースで、静かに集中してパソコン作業をする社会人の男女。白を基調とした明るいインテリアに観葉植物が映え、落ち着いた雰囲気でテレワークや勉強に適している空間を表現している。"
                        style={{ width: '100%', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
                    />
                </Box>
            </Box>

            {/* 仕事リズムに合う相手選び */}
            <Box id="roommate-selection" sx={{ mb: 5 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <PeopleAlt sx={{ mr: 1, verticalAlign: 'bottom', color: 'primary.main' }} />
                    仕事リズムに合う相手選び
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    社会人同士のルームシェアで最も重要なのは、「生活リズムや価値観の相性」です。仕事の時間帯や休日、生活スタイルが大きく異なると、小さなストレスが積もりやすくなります。
                </Typography>
                <Paper elevation={1} sx={{ p: 2, borderRadius: 2, bgcolor: '#f8fafc', mb: 2 }}>
                    <Typography variant="h6" sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                        <PersonSearch color="primary" sx={{ mr: 1 }} />
                        こんなチェックポイントを押さえよう
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircle color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="出勤・退勤時間、在宅勤務の有無"
                                secondary="朝型・夜型や、在宅日数の違いを事前に確認"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircle color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="休日の過ごし方・趣味"
                                secondary="静かに過ごしたい/アクティブに過ごしたい等"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircle color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="掃除やゴミ出しなど家事分担への姿勢"
                                secondary="ルールを共有し、合意形成を"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircle color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="音や来客に対する感覚"
                                secondary="静かさ重視/交流重視など価値観のすり合わせ"
                            />
                        </ListItem>
                    </List>
                </Paper>
                <Typography variant="body2" color="text.secondary">
                    <b>面談時には「普段の1日や1週間の過ごし方」を具体的に話し合う</b>のがミスマッチ防止のコツ。小さな違いも事前に気づければストレスを減らせます。
                </Typography>
            </Box>

            {/* テレワーク環境のポイント */}
            <Box id="telework-environment" sx={{ mb: 5 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <LaptopChromebook sx={{ mr: 1, verticalAlign: 'bottom', color: 'primary.main' }} />
                    テレワーク環境のポイント
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    コロナ禍以降、テレワークや副業など多様な働き方が定着しました。ルームシェアで快適なテレワーク環境を実現するためのポイントを押さえましょう。
                </Typography>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{ maxWidth: 345, mb: 2 }}>
                            <CardContent>
                                <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Wifi sx={{ mr: 1 }} color="primary" />
                                    安定したネット環境
                                </Typography>
                                <Typography variant="body2">
                                    回線速度やWi-Fiの強度は必ずチェック。複数人での同時接続に強い物件がベスト。
                                </Typography>
                            </CardContent>
                        </Card>
                        <Card sx={{ maxWidth: 345 }}>
                            <CardContent>
                                <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <WorkOutline sx={{ mr: 1 }} color="primary" />
                                    専用ワークスペースの有無
                                </Typography>
                                <Typography variant="body2">
                                    リビングや個室にワークデスクがあると仕事効率が大幅UP。共用の場合は予約制やルール化も◎。
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{ maxWidth: 345, mb: 2 }}>
                            <CardContent>
                                <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Bolt sx={{ mr: 1 }} color="primary" />
                                    防音・集中配慮
                                </Typography>
                                <Typography variant="body2">
                                    ドアや窓の防音性、ヘッドホン活用など工夫を。会議の時間帯調整も大切。
                                </Typography>
                            </CardContent>
                        </Card>
                        <Card sx={{ maxWidth: 345 }}>
                            <CardContent>
                                <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Star sx={{ mr: 1 }} color="primary" />
                                    共有ルールの明確化
                                </Typography>
                                <Typography variant="body2">
                                    ミーティングや通話時のルール、共用部利用のマナーを明文化しておくとトラブル防止に。
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Typography variant="body2" color="text.secondary">
                    テレワーク推進の物件では、<b>高速インターネットや防音個室、共用ワークラウンジ</b>などが人気。見学時に実際の使用感を体験してみましょう。
                </Typography>
                <Box sx={{ my: 3 }}>
                    <img
                        src="/images/blog/telework-zoning_shakaijin-no-tame-no-roomshare-erabi.jpg"
                        alt="社会人向けシェアハウスのリビングの一角に設けられたワークスペース。ガラスパーティションで仕切られた明るい空間に、パソコン作業をする男女がそれぞれ静かに仕事をしている。モダンなインテリアと機能美が調和している様子を表現。"
                        style={{ width: '100%', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
                    />
                </Box>
            </Box>

            {/* 仕事とプライベートの切り替え術 */}
            <Box id="switching-work-private" sx={{ mb: 5 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <Weekend sx={{ mr: 1, verticalAlign: 'bottom', color: 'primary.main' }} />
                    仕事とプライベートの切り替え術
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ワークライフバランスを保つには、「オン/オフの切り替え」が何より大切。ルームシェア特有のコツを活かして、心地よい日常を実現しましょう。
                </Typography>
                <Paper elevation={1} sx={{ p: 2, borderRadius: 2, bgcolor: '#f8fafc', mb: 2 }}>
                    <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Bolt sx={{ mr: 1 }} color="primary" />
                        切り替えをサポートするアイデア
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircle color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="ワークスペースとリビングのゾーニング"
                                secondary="仕事は専用デスクで、休憩は共用部や自室で"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircle color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="ルームメイトと『静寂タイム』や『交流タイム』を設定"
                                secondary="集中したい時間帯は静かに、オフタイムは一緒に過ごす"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircle color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="香りや照明を使って空間の雰囲気を変える"
                                secondary="アロマや間接照明でリセット感を演出"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <CheckCircle color="success" />
                            </ListItemIcon>
                            <ListItemText
                                primary="毎日の小さなルーティンを作る"
                                secondary="朝のコーヒー、帰宅後のシャワーなど"
                            />
                        </ListItem>
                    </List>
                </Paper>
                <Typography variant="body2" color="text.secondary">
                    <b>「空間」「時間」「習慣」の3つを意識して切り替えを工夫</b>すると、仕事もプライベートもメリハリが生まれます。
                </Typography>
            </Box>

            {/* 社会人ルームシェアの成功事例 */}
            <Box id="success-case" sx={{ mb: 5 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    <EmojiEvents sx={{ mr: 1, verticalAlign: 'bottom', color: 'primary.main' }} />
                    社会人ルームシェアの成功事例
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Typography variant="body1" sx={{ mb: 2 }}>
                    実際に社会人ルームシェアを選び、仕事も暮らしも充実させている人たちの事例をご紹介します。
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{ maxWidth: 345, mb: 2 }}>
                            <CardContent>
                                <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Group sx={{ mr: 1 }} color="primary" />
                                    事例1：異業種交流型シェア
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    30代男性（IT）＆20代女性（教育）の2人暮らし。お互いの在宅日を事前にGoogleカレンダーで共有し、会議や集中タイムが重ならない工夫。異業種ならではの刺激や情報交換が日々の活力になっているそうです。
                                </Typography>
                                <Chip label="カレンダー共有" color="primary" variant="outlined" size="small" sx={{ mr: 1 }} />
                                <Chip label="異業種交流" color="primary" variant="outlined" size="small" />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{ maxWidth: 345 }}>
                            <CardContent>
                                <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Group sx={{ mr: 1 }} color="primary" />
                                    事例2：週末リビング交流型
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    20代女性3人のルームシェア。平日はそれぞれテレワーク中心で静かに過ごし、週末はリビングで一緒に映画や食事を楽しむ「オンオフ切替型」。干渉しすぎない距離感が長続きの秘訣。
                                </Typography>
                                <Chip label="週末交流" color="primary" variant="outlined" size="small" sx={{ mr: 1 }} />
                                <Chip label="ワークライフバランス" color="primary" variant="outlined" size="small" />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Box sx={{ my: 3 }}>
                    <img
                        src="/images/blog/roommates-dining_shakaijin-no-tame-no-roomshare-erabi.jpg"
                        alt="明るい共有リビングで複数人の社会人ルームメイトがダイニングテーブルを囲み、和やかに食事しながら交流している。カジュアルな雰囲気と笑顔が溢れ、仕事とプライベートの絶妙なバランスを感じさせるシーン。"
                        style={{ width: '100%', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}
                    />
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                    どちらの事例も、「お互いのワークスタイル」や「交流のタイミング」を適度に調整し合うことで、ストレスなく快適なルームシェア生活を実現しています。
                </Typography>
            </Box>

            {/* まとめ */}
            <Box sx={{ mb: 6 }}>
                <Divider sx={{ my: 4 }} />
                <Typography variant="h4" component="h2" gutterBottom>
                    快適な社会人ルームシェアで、仕事も人生も豊かに
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    社会人のルームシェアは、単なる「家賃を抑える手段」ではなく、<b>仕事効率・暮らしの質・人とのつながり</b>を同時に高められる、現代的なライフスタイルの一つです。自分に合った物件とルームメイト選び、環境づくりの工夫で、あなたの毎日がもっと充実するはず。ぜひこの記事を参考に、快適な新生活をスタートしてください。
                </Typography>
            </Box>
        </Box>
    );
};

const post = {
    id: 'shakaijin-no-tame-no-roomshare-erabi',
    slug: 'shakaijin-no-tame-no-roomshare-erabi',
    title: '社会人のためのルームシェア選び：仕事と両立する快適な住環境の作り方',
    excerpt: '社会人向け物件の特徴、仕事リズムに合う相手選び、テレワーク環境、仕事とプライベートの切り替え、成功事例――社会人に最適なルームシェアの選び方・実践ノウハウを詳しく解説。',
    coverImage: '/images/blog/cover-roomshare-modern-living_shakaijin-no-tame-no-roomshare-erabi.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが楽しく会話をしている様子。ウッド調の家具やグリーンが配置され、落ち着いた雰囲気と親しみやすさを感じさせる、社会人の快適な住環境を象徴するシーン。',
    publishedAt: '2024-06-11T00:00:00.000Z',
    isPublished: true,
    categories: ['ルームシェア', '社会人ライフ', '住まい選び'],
    tags: ['社会人ルームシェア', 'テレワーク', '物件選び', 'ワークライフバランス', '成功事例'],
    author: {
        name: '大澤 直樹',
        avatar: '/images/avatars/osawa-naoki.jpg',
        bio: '住まいと働き方の最新トレンドを取材・発信するライフスタイルジャーナリスト。現代の多様な住まい選びやルームシェアの最前線に精通し、実例取材と現場視点のアドバイスを多数執筆。',
        profilePicture: '/images/avatars/osawa-naoki.jpg'
    },
    viewCount: 1280,
    contentComponent: PostContent
};

export default post;